module.exports = __webpack_public_path__ + "static_pc/img/gj03.6294110d.png";